import React from "react";
import { NavLink } from "react-router-dom";
import Button from "../../components/button/button";

// import "./NavigationItems.css";
import "./activities.css";

function ActivitiesContainer(props) {
  return (
    <>
      <div id="activitiesPage" className="page">
        <h1>Activities</h1>
        <hr />
        {props.isAuth && (
          <Button design="raised" mode="accent" onClick={props.onAddActivities}>
            New activitie
          </Button>
        )}
        <ul id="activities-items">{props.children}</ul>
      </div>
    </>
  );
}

export default ActivitiesContainer;
